import React, { useCallback } from "react";

import { faPaperclip } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification } from "antd";
import Tooltip from "antd/es/tooltip";
import Upload, { UploadProps } from "antd/es/upload/Upload";
import { UploadRequestOption } from "rc-upload/lib/interface";

import { useConfigProvider } from "../../../../ConfigProvider";
import ActionCallback from "../../type/ActionCallback";
import FileAttachCallback from "../../type/FileAttachCallback";
import ToggleButton from "../ToggleButton";

import styles from "./FilesAttach.module.scss";

const FILE_SIZE_LIMIT = 25 * 1024 * 1024;

interface FilesAttachProps {
  onAction?: ActionCallback;
  onAttach?: FileAttachCallback;
}

const FilesAttach = ({ onAction, onAttach }: FilesAttachProps) => {
  const configProvider = useConfigProvider();

  const handleCustomRequest = useCallback(
    async ({ file }: UploadRequestOption) => {
      onAttach?.(file as File);
    },
    [onAttach]
  );

  const handleBeforeUpload = useCallback<NonNullable<UploadProps["beforeUpload"]>>(
    (file) => {
      if (file.size > FILE_SIZE_LIMIT) {
        notification.error({
          message: (
            <div>
              <div className={styles.errorTitle}>
                {configProvider.formatMessage(
                  "ui.emailBody.actions.filesAttach.largeFilesWarning.title"
                )}
              </div>
              <div className={styles.errorDescription}>
                {configProvider.formatMessage(
                  "ui.emailBody.actions.filesAttach.largeFilesWarning.description"
                )}
              </div>
            </div>
          ),
        });
        return false;
      }
      return true;
    },
    [configProvider]
  );

  const handleClick = useCallback(() => {
    onAction?.("Attach Files");
  }, [onAction]);

  return (
    <Upload
      beforeUpload={handleBeforeUpload}
      customRequest={handleCustomRequest}
      fileList={[]}
      multiple
    >
      <Tooltip title={configProvider.formatMessage("ui.emailBody.actions.attachFiles")}>
        <ToggleButton onClick={handleClick}>
          <FontAwesomeIcon icon={faPaperclip} />
        </ToggleButton>
      </Tooltip>
    </Upload>
  );
};

export default FilesAttach;
